module.exports = __webpack_public_path__ + "static/media/bg-user-chat-dots.59d8de1e.svg";